import { Breadcrumb } from "@gull";
import { useCallback, useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";

import HandyScroll from "app/common/Scroll";
import usePagePermission from "app/hooks/usePagePermission";
import queryString from "app/services/queryStringService";
import moment from "moment";
import { Helmet } from "react-helmet";

import {
  getRegion,
  addUpdateRegion,
  deleteRegion,
} from "app/services/RegionService";
import {
  Dropdown,
  DropdownButton,
  Form,
  Row,
  Col,
  Button,
  Card,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { FaUserCheck } from "react-icons/fa";
import Swal from "sweetalert2";
import { MdDelete } from "react-icons/md";
import { NotificationManager } from "react-notifications";

function Region() {
  const { canAdd, canView, canEdit, canDelete } = usePagePermission();

  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const [sizePerPage, setSizePerPage] = useState(10);
  const [dataCount, setDataCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [btnLoading, setBtnLoading] = useState(false);

  const initialData = {
    id: 0,
    regionName: "",
    description: "",
    status: true,
  };

  const [formData, setFormData] = useState(initialData);

  const [filters, setFilters] = useState({
    fromDate: "",
    toDate: "",
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const resetForm = () => {
    setFormData(initialData);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setBtnLoading(true);

      const payload = {
        id: formData.id,
        regionName: formData.regionName,
        description: formData.description,
        status: formData.status,
      };

      const res = await addUpdateRegion(payload);
      console.log(res);
      if (res.data.status == "Success") {
        NotificationManager.success(res.data.message);
      } else {
        NotificationManager.success(res.data.message);
      }

      //   alert(
      //     formData.id !== 0
      //       ? "Region Updated Successfully"
      //       : "Region Added Successfully",
      //   );

      resetForm();
      loadRegion();
    } catch (error) {
      console.error(error);
    } finally {
      setBtnLoading(false);
    }
  };

  const handleEdit = (row) => {
    setFormData({
      id: row.id || 0,
      regionName: row.regionName || "",
      description: row.description || "",
      status: row.status ?? true,
    });

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const dateFormatter = useCallback((cell) => {
    return cell ? (
      <div>
        <div>{moment(cell).format("DD/MM/YYYY")}</div>
        <div>{moment(cell).format("HH:mm")}</div>
      </div>
    ) : (
      "-"
    );
  }, []);

  const statusFormatter = useCallback((cell) => {
    return cell !== undefined && cell !== null ? (
      <span
        style={{
          color: cell ? "green" : "red",
          fontWeight: "600",
        }}
      >
        {cell ? "Active" : "Inactive"}
      </span>
    ) : (
      "-"
    );
  }, []);

  const handleDelete = async (row) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: `You want to delete "${row.regionName}" region`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        // cancelButtonColor: "#3085d6",
        confirmButtonText: "Yes, Delete",
        cancelButtonText: "Cancel",
      });

      if (result.isConfirmed) {
        // delete payload
        debugger;

        const res = await deleteRegion(row.id);
        console.log(res);

        Swal.fire({
          title: "Deleted!",
          text: res?.data?.message,
          icon: res?.data?.status?.toLowerCase(),
          timer: 2000,
          showConfirmButton: false,
          toast: true,
        });

        loadRegion();

        // if deleting currently editing row
        if (formData.id === row.id) {
          resetForm();
        }
      }
    } catch (error) {
      console.error(error);

      Swal.fire({
        title: "Error!",
        text: "Something went wrong",
        icon: "error",
      });
    }
  };
  const actionFormatter = (cell, row) => {
    return (
      <>
        <DropdownButton variant="outline-primary" title="Action" size="sm">
          <Dropdown.Item
            className="text-primary"
            onClick={() => handleEdit(row)}
          >
            <FaUserCheck className="me-2" />
            Edit Region
          </Dropdown.Item>

          <OverlayTrigger
            placement="top"
            overlay={
              row.status ? (
                <Tooltip>This region is active and cannot be deleted</Tooltip>
              ) : (
                <></>
              )
            }
          >
            <span>
              <Dropdown.Item
                disabled={row.status}
                className={row.status ? "text-muted" : "text-danger"}
                onClick={() => !row.status && handleDelete(row)}
              >
                <MdDelete className="me-2" />
                Delete Region
              </Dropdown.Item>
            </span>
          </OverlayTrigger>
        </DropdownButton>
      </>
    );
  };

  const columns = [
    {
      dataField: "id",
      text: "Action",
      formatter: actionFormatter,
      headerStyle: () => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "regionName",
      text: "Name",
      headerStyle: () => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "description",
      text: "Description",
      headerStyle: () => {
        return { width: "200px", textAlign: "center" };
      },
    },
    {
      dataField: "status",
      text: "Status",
      formatter: statusFormatter,
      headerStyle: () => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "createdAt",
      text: "Created At",
      formatter: dateFormatter,
      headerStyle: () => {
        return { width: "180px", textAlign: "center" };
      },
    },
    {
      dataField: "updatedAt",
      text: "Updated At",
      formatter: dateFormatter,
      headerStyle: () => {
        return { width: "180px", textAlign: "center" };
      },
    },
  ];

  function rowStyle(row, rowIndex) {
    return {
      textAlign: "center",
      fontWeight: "600",
      verticalAlign: "middle",
    };
  }

  function NoDataIndication() {
    if (loading) {
      return (
        <div className="jumbotron jumbotron-fluid min-vh-80 m-0 bg-white"></div>
      );
    }

    return (
      <div className="jumbotron min-vh-80 text-middle m-0 text-center d-flex flex-column justify-content-center">
        <p>No Data Found</p>
      </div>
    );
  }

  const loadRegion = useCallback(async () => {
    try {
      setLoading(true);

      const query = queryString.getQueryStringFromObj({
        pageNumber: page,
        pageSize: sizePerPage,
        ...filters,
      });

      const response = await getRegion(query);

      setData(response?.data?.data || []);

      // if pagination available
      const paginationData = JSON.parse(response.headers["x-pagination"]);
      setDataCount(paginationData.TotalCount);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, [filters, page, sizePerPage]);

  useEffect(() => {
    loadRegion();
  }, [loadRegion]);

  const handleTableChange = useCallback((type, { page, sizePerPage }) => {
    setPage(page);
    setSizePerPage(sizePerPage);
  }, []);

  const sizePerPageRenderer = ({
    options,
    currSizePerPage,
    onSizePerPageChange,
  }) => (
    <>
      <label className="mr-2">Page Size</label>

      <div className="btn-group mr-4" role="group">
        {options.map((option) => {
          const isSelect = currSizePerPage === `${option.page}`;

          return (
            <button
              key={option.text}
              type="button"
              onClick={() => onSizePerPageChange(option.page)}
              className={`btn btn-sm ${
                isSelect ? "btn-primary" : "btn-secondary"
              }`}
            >
              {option.text}
            </button>
          );
        })}
      </div>
    </>
  );

  const paginationOptions = {
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    showTotal: true,
    totalSize: dataCount,
    sizePerPageList: [
      {
        text: "10",
        value: 10,
      },
      {
        text: "15",
        value: 15,
      },
      {
        text: "20",
        value: 20,
      },
      {
        text: "50",
        value: 50,
      },
    ],
    sizePerPageRenderer,
  };

  return (
    <>
      <Helmet>
        <title>Region</title>
      </Helmet>

      <Breadcrumb routeSegments={[{ name: "Region" }]} />

      {/* Add / Update Form */}
      <Card className="mb-4">
        <Card.Header className="bg-primary text-white fw-bold">
          {formData.id !== 0 ? "Update Region" : "Add Region"}
        </Card.Header>

        <Card.Body>
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Region Name</Form.Label>

                  <Form.Control
                    type="text"
                    name="regionName"
                    value={formData.regionName}
                    onChange={handleChange}
                    placeholder="Enter Region Name"
                    required
                  />
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Description</Form.Label>

                  <Form.Control
                    type="text"
                    name="description"
                    value={formData.description}
                    onChange={handleChange}
                    placeholder="Enter Description"
                  />
                </Form.Group>
              </Col>

              <Col md={2}>
                <Form.Group className="mb-3">
                  <Form.Label>Status</Form.Label>

                  <div>
                    <Form.Check
                      type="switch"
                      id="status-switch"
                      label={formData.status ? "Active" : "Inactive"}
                      name="status"
                      checked={formData.status}
                      onChange={handleChange}
                    />
                  </div>
                </Form.Group>
              </Col>

              <Col
                md={2}
                className="d-flex align-items-center justify-content-start"
              >
                <div className="mt-2">
                  <Button
                    type="submit"
                    variant={formData.id !== 0 ? "warning" : "primary"}
                    disabled={btnLoading}
                  >
                    {btnLoading
                      ? "Please Wait..."
                      : formData.id !== 0
                        ? "Update"
                        : "Add"}
                  </Button>

                  <Button
                    type="button"
                    variant="secondary"
                    className="ms-2"
                    onClick={resetForm}
                  >
                    Reset
                  </Button>
                </div>
              </Col>
            </Row>
          </Form>
        </Card.Body>
      </Card>

      <HandyScroll>
        <div
          className="spacious-container"
          data-handy-scroll
          style={{ overflow: "auto" }}
        >
          <BootstrapTable
            hover
            remote
            keyField="id"
            data={data}
            columns={columns}
            pagination={paginationFactory(paginationOptions)}
            onTableChange={handleTableChange}
            noDataIndication={() => <NoDataIndication />}
            headerClasses="bg-primary text-white"
            bodyClasses="react-bootstrap-table-next-min-height"
            rowStyle={rowStyle}
          />
        </div>
      </HandyScroll>
    </>
  );
}

export default Region;
